export default "__VITE_ASSET__$lJehrUO__"